export default __webpack_public_path__ + "greece.c6fdd948.png";